import {
    LOAD_ACTIVITY_TYPES,
    ADD_ACTIVITY_TYPE,
    UPDATE_ACTIVITY_TYPE,
    DELETE_ACTIVITY_TYPE,
} from "./activityTypesConstants";

export default function (state, { type, payload }) {
    switch (type) {
        case LOAD_ACTIVITY_TYPES:
            return { activityTypes: payload };
        case ADD_ACTIVITY_TYPE:
            return { activityTypes: [...state.activityTypes, payload] };
        case UPDATE_ACTIVITY_TYPE: {
            const activityTypeToUpdate = state.activityTypes.find((activityType) => activityType.id === payload.id);
            return {
                activityTypes: [
                    ...state.activityTypes.filter((activityType) => activityType.id !== payload.id),
                    Object.assign({}, activityTypeToUpdate, { payload }),
                ],
            };
        }
        case DELETE_ACTIVITY_TYPE:
            return { activityTypes: state.activityTypes.filter((activityType) => activityType.id !== payload) };
        default:
            return state;
    }
}

export function activityTypesHasErrored(state = false, action) {
    switch (action.type) {
        case "ACTIVITY_TYPES_HAS_ERRORED":
            return action.hasErrored;
        default:
            return state;
    }
}
export function activityTypesIsLoading(state = false, action) {
    switch (action.type) {
        case "ACTIVITY_TYPES_IS_LOADING":
            return action.isLoading;
        default:
            return state;
    }
}
export function activityTypes(state = [], action) {
    switch (action.type) {
        case "LOAD_ACTIVITY_TYPES":
            return action.activityTypes;
        default:
            return state;
    }
}
